import cls from 'classnames'
import React from 'react'
import { useHistory, useRouteMatch } from 'react-router-dom'

import s from './aside.module.less'

interface AsideMenuItemProps {
  title: React.ReactElement | string
  path: string
  icon: React.ReactElement
  actions?: React.ReactElement
  exact?: boolean
}

export const AsideMenuItem: React.FC<AsideMenuItemProps> = ({ title, path, icon, actions, exact = true }) => {
  const history = useHistory()
  const match = useRouteMatch({
    path,
    exact,
  })

  const onClick = () => {
    history[match ? 'replace' : 'push'](path)
  }

  const iconComponent = React.cloneElement(icon, {
    className: s.contentItemIcon,
  })

  return (
    <div className={cls(s.contentItem, { [s.isActive]: !!match })} onClick={onClick}>
      {iconComponent}
      <span className={s.contentTitle}>{title}</span>
      {actions}
    </div>
  )
}
